<template>
  <v-row>
    <!-- Leva kolona - Tip limita -->
    <v-col cols="12" md="6">
      <LimitTypeSelector :config="config" :readonly="readonly" />
    </v-col>

    <!-- Desna kolona - Vremenski limit -->
    <v-col v-if="config.limit_definition.active !== 'unlimited'" cols="12" md="6">
      <TimeLimitSelector :config="config" :readonly="readonly" />
    </v-col>
  </v-row>
</template>

<script>
import LimitTypeSelector from "../sections/LimitTypeSelector.vue";
import TimeLimitSelector from "../sections/TimeLimitSelector.vue";

export default {
  name: "Step1Combined",
  components: {
    LimitTypeSelector,
    TimeLimitSelector,
  },
  props: {
    config: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
